module.exports = __webpack_public_path__ + "static/media/02.e56a4326.png";